export default __webpack_public_path__ + "static/media/pawn.4748b75f.png";